export const TOGGLE_THEME = 'TOGGLE_THEME';
export const LOADING = 'LOADING';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SHOW_SNACKBAR_INDEEP = 'SHOW_SNACKBAR_INDEEP';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const INITIALLY_RENDERED = 'INITIALLY_RENDERED';
export const SHOW_MODAL = 'SHOW_MODAL';
export const UPDATE_NODED = 'UPDATE_NODED';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_ACTIVE_LINK = 'SET_ACTIVE_LINK';
